import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const imagesWithBlurSchema = Joi.object({
  image: mediaUrlSchema,
  blur: mediaUrlSchema
}).unknown(true);
export default imagesWithBlurSchema;